// extracted by mini-css-extract-plugin
export default {"container":"AssignInfo_container__T2ikA","assignBtn":"AssignInfo_assignBtn__pmFOI"};